module.exports = __webpack_public_path__ + "assets/favicon.d838b45a.ico";